// src/pages/Dashboard/CreatePageWizard/Step3Links.jsx

function Step3Links({
 instagram,
 setInstagram,
 facebook,
 setFacebook,
 twitter,
 setTwitter,
 youtube,
 setYoutube,
 email,
 setEmail,
}) {
 return (
  <div className="card">
   <h2>About & Socials</h2>


   <div className="row-2">
    <label className="field">
     <span>Instagram (optional)</span>
     <input
      value={instagram}
      onChange={(e) => setInstagram(e.target.value)}
      placeholder="https://instagram.com/yourpage"
     />
    </label>

    <label className="field">
     <span>Facebook (optional)</span>
     <input
      value={facebook}
      onChange={(e) => setFacebook(e.target.value)}
      placeholder="https://facebook.com/yourpage"
     />
    </label>
   </div>

   <div className="row-2">
    <label className="field">
     <span>Twitter / X (optional)</span>
     <input
      value={twitter}
      onChange={(e) => setTwitter(e.target.value)}
      placeholder="https://x.com/yourpage"
     />
    </label>

    <label className="field">
     <span>YouTube (optional)</span>
     <input
      value={youtube}
      onChange={(e) => setYoutube(e.target.value)}
      placeholder="https://youtube.com/yourchannel"
     />
    </label>
   </div>

   <label className="field">
    <span>Email (optional)</span>
    <input
     value={email}
     onChange={(e) => setEmail(e.target.value)}
     placeholder="contact@email.com"
    />
   </label>

   <div className="muted small">You can leave these blank and add later.</div>
  </div>
 );
}

export default Step3Links;